import { defineMessages } from 'react-intl-next';

export const messages: {
	eventLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	meetingLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	joinMeetingLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	meetingLinkIcon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recurringEventIcon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recurringMetadataLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	upcomingEventsButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pastEventsButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	created: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	externalPerson: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	eventLabel: {
		id: 'search-graph-calendar.calendar-label',
		defaultMessage: 'Calendar',
		description: 'Calendar event subtype label',
	},
	meetingLink: {
		id: 'search-graph-calendar.meeting-link',
		defaultMessage: 'Meeting link',
		description: 'Calendar event meeting link label',
	},
	joinMeetingLink: {
		id: 'search-graph-calendar.join-meeting-link',
		defaultMessage: 'Join meeting',
		description: 'Calendar event join upcoming meeting link',
	},
	meetingLinkIcon: {
		id: 'search-graph-calendar.meeting-link-icon',
		defaultMessage: 'Join meeting',
		description: 'Calendar event join upcoming meeting icon',
	},
	recurringEventIcon: {
		id: 'search-graph-calendar.recurring-event-icon',
		defaultMessage: 'Recurring event',
		description: 'Calendar event recurring event icon',
	},
	recurringMetadataLabel: {
		id: 'search-graph-calendar.recurring-event-label',
		defaultMessage: 'Recurring',
		description: 'Indicates whether the calendar event has recurring events',
	},
	upcomingEventsButton: {
		id: 'search-graph-calendar.upcoming-events-button',
		defaultMessage: 'Upcoming events',
		description: 'Label for the call to action to display the upcoming events',
	},
	pastEventsButton: {
		id: 'search-graph-calendar.past-events-button',
		defaultMessage: 'Past events',
		description: 'Label for the call to action to display the past events',
	},
	created: {
		id: 'search-graph-calendar.created.placeholder',
		defaultMessage: '{person} created',
		description: 'Calendar event created by label',
	},
	externalPerson: {
		id: 'search-graph-calendar.external-person',
		defaultMessage: 'External person',
		description: 'Calendar event external person label in case name cannot be fetched',
	},
});
